/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import jobStyles from "./jobStyles";
import TextContainer from "../../Container/TextContainer";
import { Helmet } from "react-helmet-async";
import Layout from "../../../containers/Layouts/Layout";
import BenefitsLegalbirdTech from "./BenefitsLegalbirdTech";
import SendApplication from "./SendApplication";
import { gaSet } from "../../../services/cookieService";
import Typography from "@mui/material/Typography";
import HeadlineSection from "../../Sections/Generic/HeadlineSection/HeadlineSection";
import cvImage from "../../../assets/img/jobs/cv.svg";
import { Box } from "@mui/material";
import MuiListNativeStyled from "../../List/MuiListNativeStyled";

const ProductManager = () => {
  const title = "Jobs - Rechtsanwältin/Rechtsanwalt | Legalbird";
  gaSet({ title: title });

  return (
    <Layout backgroundType={"landingpage"}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <HeadlineSection headline={"Produktmanager Legal Tech (m/w/d)"} image={cvImage} />
      <TextContainer sx={jobStyles.container}>
        <Typography>
          Mit unserer starken Onlinekompetenz, hoher juristischer Expertise und innovativer, computergestützter Automatisierung helfen wir unseren Kunden, ihre
          rechtlichen Fragestellungen sicher, schnell und kostengünstig online zu lösen.
        </Typography>
        <Typography>
          Du hast Lust auf ein stark wachsendes Unternehmen und darauf, den Rechtsberatungsmarkt mit Hilfe modernster digitaler Technologien zu verändern? Du
          ziehst es vor, in einem produktiven Umfeld zu arbeiten, in dem Du viele Sachen selbstverantwortlich in die Hand nehmen kannst? Du schätzt eine offene
          Atmosphäre, in der es Spaß macht immer wieder über sich hinauszuwachsen? Dann bewirb Dich bei uns!
        </Typography>
      </TextContainer>
      <Box>
        <TextContainer sx={jobStyles.container}>
          <Typography variant={"h4"}>Was Deine Aufgaben sein werden</Typography>
          <Typography>
            Du bist zuständig für die Servicewelt des Kunden und für unser eigenes CRM-System zur Mandantenbetreuung und sorgst dafür, dass alles Hand-in-Hand
            funktioniert. Dazu gehört:
          </Typography>
          <br />
          <MuiListNativeStyled
            sx={jobStyles.list}
            listItems={[
              "Die Entwicklung neuer Features in Zusammenarbeit mit unserem Legal-Team und der IT",
              "Die Optimierung des eigenen CRM-Systems für unsere internen und externen Anwälte",
              "Das Erstellen von Tickets in Jira und die Priorisierung des Backlogs",
            ]}
          />
          <Typography variant={"h4"}>Was Du dazu brauchst</Typography>
          <MuiListNativeStyled
            sx={jobStyles.list}
            listItems={[
              "Du hast Spaß an Produktmanagement und bestenfalls Vorerfahrung von mindestens 1-2 Jahren",
              "Du hast ein gutes Gefühl für Nutzer-Bedürfnisse und übernimmst gerne Verantwortung für Dein Produkt und die Umsetzung neuer Features",
              "Du hast schon mit Jira gearbeitet und kommunizierst gerne direkt mit der IT",
              "Du liebst Herausforderungen und brennst dafür, diese optimal und kreativ zu lösen",
              "Vorerfahrung im Rechtsbereich wäre zwar schön, ist aber nicht notwendig",
            ]}
          />
        </TextContainer>
      </Box>
      <BenefitsLegalbirdTech />
      <SendApplication to={"Melanie Treude"} />
    </Layout>
  );
};

export default ProductManager;
